import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getActiveSurveyOperation, submitSurveyOperation } from './survey-operations';
import { SubmitAnswerDTO, SurveyState } from './SurveyTypes';

const initSurvey = {
  survey_id: 0,
  name: '',
  created_at: '',
  blocks: [],
};

const initialState: SurveyState = {
  survey: initSurvey,
  loadingSurvey: false,

  answers: [],
  userInputAnswers: [],

  instanceId: null,
  submitting: false,

  error: null,
};

const surveySlice = createSlice({
  name: 'survey',
  initialState,
  reducers: {
    /* если нужно очистить результаты (например при logout) */
    resetSurveyState: () => initialState,
    /** добавить или обновить один ответ */
    setAnswer: (state, { payload }: PayloadAction<SubmitAnswerDTO>) => {
      const answers = state.answers;
      const question_id = payload.question_id;

      const idx = answers.findIndex(a => a.question_id === question_id);
      if (idx === -1) state.answers.push(payload); // новый вопрос
      else state.answers[idx] = payload; // обновляем существующий
    },

    /** заменить все ответы разом */
    setAnswers: (state, { payload }: PayloadAction<SubmitAnswerDTO[]>) => {
      state.answers = payload;
    },

    /** очистить ответы вручную */
    clearAnswers: state => {
      state.answers = [];
    },

    /** изменить флаг вручную */
    setSubmitting: (state, { payload }: PayloadAction<boolean>) => {
      state.submitting = payload;
    },
  },
  extraReducers: builder => {
    /* --- GET active survey --- */
    builder.addCase(getActiveSurveyOperation.pending, state => {
      state.loadingSurvey = true;
      state.error = null;
    });
    builder.addCase(getActiveSurveyOperation.fulfilled, (state, { payload }) => {
      state.survey = payload;
      state.loadingSurvey = false;
    });
    builder.addCase(getActiveSurveyOperation.rejected, (state, { payload, error }) => {
      state.loadingSurvey = false;
      state.error = payload?.message || error.message || null;
    });

    /* --- POST submit answers --- */
    builder.addCase(submitSurveyOperation.pending, state => {
      state.error = null;
    });
    builder.addCase(submitSurveyOperation.fulfilled, (state, { payload }) => {
      state.instanceId = payload.instance_id;
      state.answers = [];
      state.survey = initSurvey;
    });
    builder.addCase(submitSurveyOperation.rejected, (state, { payload, error }) => {
      state.error = payload?.message || error.message || null;
    });
  },
});

export const { resetSurveyState, setAnswer, setAnswers, clearAnswers, setSubmitting } =
  surveySlice.actions;
export default surveySlice.reducer;
